import React, { useEffect, useState } from 'react';
import DefaultLayout from './DefaultLayout';
import { useDispatch, useSelector } from 'react-redux';
import { getAllCars } from '../redux/actions/carsActions';
import { Col, Row, DatePicker, Edit } from 'antd';
import Spinner from '../components/Spinner';
import { Link } from 'react-router-dom';
import { deleteCar } from '../redux/actions/carsActions';
import { Button, message, Popconfirm } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Navigate } from 'react-router-dom';





function AdminHome() {
  const { cars } = useSelector(state => state.cars);
  const { loading } = useSelector(state => state.alertsReducer);
  const [totalCars, setTotalcars] = useState([]);
  const dispatch = useDispatch();

  const user = JSON.parse(localStorage.getItem('user'));


  useEffect(() => {
    // Fetch cars data from the server
    dispatch(getAllCars());
  }, [dispatch]);

  useEffect(() => {
    // Update the available cars whenever the car data changes
    setTotalcars(cars);
  }, [cars]);


  // ✅ Redirect after hooks
  if (!user || user.user.role !== 'admin') {
    return <Navigate to="/" />;
  }



  return (
    <DefaultLayout>

      <Row justify='center mt-3' gutter={16}>
        <Col lg={20} sm={24}>
          <div className='d-flex justify-content-between align-items-center'>
            <h2 className='mt-2'>ADMIN PORTAL</h2>
            <button className='btn1'><Link to='/addcar'>ADD CAR</Link></button>
          </div>
        </Col>
      </Row>

      {loading === true && (<Spinner />)}
      <Row justify='center' gutter={16}>
        {totalCars.map(car => {
          const confirm = (carId) => {
            dispatch(deleteCar({ _id: carId }));
            message.success('Car deleted successfully');
          };

          const cancel = () => {
            message.error('Deletion cancelled');
          };

          return (
            <Col lg={6} md={8} sm={24} xs={24} key={car._id}>
              <div className='car p-2 bs1'>
                <img src={car.image} className='carimg'  alt='a car'/>
                <div className='car-content d-flex align-items-center justify-content-between'>
                  <div className='text-left pl-2'>
                    <p>{car.make}</p>
                    <p>Rate Per Hour {car.rentPerHour} /-</p>
                  </div>
                  <div className='mr-3'>
                    <Link to={`/editcar/${car._id}`}>
                      <EditOutlined style={{ color: 'teal', cursor: 'pointer' }} className='mr-3' />
                    </Link>
                    <Popconfirm
                      title="Delete the task"
                      description="Are you sure to delete this car?"
                      onConfirm={() => confirm(car._id)}
                      onCancel={(e) => {
                        console.log(e);
                        message.error('Click on No');
                      }}
                      okText="Yes"
                      cancelText="No"
                    >
                      <DeleteOutlined style={{ color: 'red', cursor: 'pointer' }} />
                    </Popconfirm>

                  </div>
                </div>
              </div>
            </Col>
          );
        })}
      </Row>
    </DefaultLayout>
  );
}

export default AdminHome;
